import { css } from 'lit';

export const DxoStylesDark = css`
  :host([theme="dark"]) .primary-header {
    background-color: #00132B;
  }

  :host([theme="dark"]) .subheader {
    background-color: hsl(0, 0%, 12%);
    box-shadow: inset 0 -1px 0 hsl(0, 0%, 21%);
  }

  :host([theme="dark"]) .subheader-tab {
    color: hsl(0, 0%, 100%);
  }

  :host([theme="dark"]) .subheader-dropdown {
    background-color: hsl(0, 0%, 12%);
  }

  :host([theme="dark"]) .subheader-dropdown-link {
    color: hsl(0, 0%, 100%);
  }

  :host([theme="dark"]) .logout-dropdown {
    background-color: hsl(0, 0%, 12%);
  }

  :host([theme="dark"]) .logout-dropdown-name {
    color: hsl(0, 0%, 100%);
  }

  :host([theme="dark"]) .dropdown-button-signout {
    background-color: hsl(0, 0%, 12%);
  }

  :host([theme="dark"]) .login-button {
    background-color: transparent;
    color: hsl(0, 0%, 100%);
    border-color: rgba(255, 255, 255, 0.5);
  }

  :host([theme="dark"]) .login-button:hover {
    color: hsl(0, 0%, 100%);
    border-color: rgba(255, 255, 255, 0.8);
  }

  :host([theme="dark"]) .login-button svg path {
    fill: hsl(0, 0%, 100%);
  }

`;
